/**
 * Capabilities.tsx — plattformfunksjoner i rutenett (2 / 3 kolonner)
 */

import type { LandingContent } from '@/types/landing';
import { LANDING_ICONS } from './landing-icons';
import styles from './landing-sections.module.css';

export default function Capabilities({
  capabilities,
  id = 'funksjoner',
  plain = false,
}: {
  capabilities: LandingContent['capabilities'];
  id?: string;
  /** true: hvit bakgrunn (for å veksle med grå seksjoner rundt) */
  plain?: boolean;
}) {
  return (
    <section id={id} className={plain ? styles.section : styles.sectionAlt} aria-labelledby="capabilities-heading">
      <div className={styles.container}>
        <h2 id="capabilities-heading" className={styles.h2}>
          {capabilities.heading}
        </h2>

        <ul className={styles.capabilities} role="list">
          {capabilities.items.map((item) => {
            const Icon = LANDING_ICONS[item.icon];
            return (
              <li key={item.title} className={styles.capability}>
                <Icon className={styles.pictogram} aria-hidden />
                <h3 className={styles.h3}>{item.title}</h3>
                <p className={styles.tileText}>{item.body}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
